export default __webpack_public_path__ + "static/media/car2.f6806020.svg";